export const seasonalDates = [
    {
      id: '2026-01-01',
      name: 'Nieuwjaarsdag',
      days: ['2026-01-01'],
    },
    {
      id: '2026-04-easter',
      name: 'Pasen',
      days: ['2026-04-03', '2026-04-04', '2026-04-05', '2026-04-06'],
    },
    // {
    //   id: '2025-05-ascension',
    //   name: 'Hemelvaart',
    //   days: ['2025-05-28', '2025-05-29', '2025-05-30'],
    // },
    {
      id: '2026-06-pentecost',
      name: 'Pinksteren',
      days: ['2026-05-21', '2026-05-22', '2026-05-23', '2026-05-24', '2026-05-25'],
    },
    {
      id: '2025-11-black-friday',
      name: 'Black Friday Week',
      days: ['2026-11-24', '2026-11-25', '2026-11-26', '2026-11-27', '2026-11-28', '2026-11-29', '2026-11-30'],
    },
    {
      id: '2025-12-christmas',
      name: 'Kerst Oudejaarsdag',
      days: ['2026-12-17', '2026-12-18', '2026-12-19', '2026-12-20', '2026-12-21', '2026-12-22', '2026-12-23', '2026-12-24', '2026-12-25', '2026-12-26', '2026-12-27', '2026-12-28', '2026-12-29', '2026-12-30', '2026-12-31'],
    },
  ];